import React, { Component } from "react";
import config from "react-global-configuration";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import "../assets/css/datatables/datatables.min.css";
import "../assets/css/react-confirm-alert/react-confirm-alert.css";
import Select from "react-select";
import "react-calendar/dist/Calendar.css";
import "./css/ipos-navbar.css";
import "./css/TotalEMI.css";
import Emitabs from "./js/TenureTabs";
import "react-responsive-tabs/styles.css";
import MobNavbar from "./js/BottomNav";
import { isMobile } from "react-device-detect";
import "./css/TotalEMI.css";
import TopNavbar from "ipos/js/ProfileTopbar";

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';
// import SweetAlert from 'sweetalert2-react';
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import {connect}  from  "react-redux";



const reportstyle = {
  backgroundColor: "#eee",
  border: "1px solid #ccc",
  margin: "5px 0px",
  // borderRadius: "5px",
};

const override = css`
    position:absolute;
    display: inline-block;
    margin-left:40%;
    margin-top:150px;
    border-color: red;
    text-align: center;
`;

const three = "3 MONTHS";
const six = "6 MONTHS";
const nine = "9 MONTHS";
const twelve = "12 MONTHS";
var currTenure = "";

const calculateEMIReq = {
  merchantId: '',
  emiTenures: [],
  amount: '',
  bankName: '',
  loginSessionId: '',
  name: '',
  appVersion: "2.1"
};
const tenureselcted =
{
  backgroundColor: '#565656',
  color: '#fff',
  border: 'solid 1px',
  borderRadius: '10px',
}
const tenurenotselcted =
{
  border: 'darkgray solid 1px',
  borderRadius: '10px',
}

const presidents = [
  { name: "George Washington", biography: "..." },
  { name: "Theodore Roosevelt", biography: "..." },
];
let InputAmt = '';

class IposTools extends Component {
  constructor(props) {
    super(props);
    this.headerText = [{ text: "3 months" }, { text: "6 months" }, { text: "9 months" }, { text: "12 months" },];
    this.state = {
      startDate: new Date(),
      name: "React",
      monthpick: { display: "none" },
      daypick: { display: "none" },
      buttongen: { display: "none" },
      orange: { color: "darkorange" },
      uploadDropdown: true,
      isDisabled: true,
      availableReport: false,
      csvData: "",
      s_date: "",
      e_date: "",
      emitabshow: false,
      Emidetailshow: false,
      items: this.getTabs(),
      drop: false,
      terminalNo: '',
      userName: '',
      sessionId: '',
      merchantId:'',
      BankList: [],
      EmiTenures: {},
      Banks: {},
      EmiAmt: '',
      threeMonths: tenurenotselcted,
      sixMonths: tenurenotselcted,
      nineMonths: tenurenotselcted,
      twelveMonths: tenurenotselcted,
      alert: false,
      alertMsg:'',
      loader: false,
      leftloader: false,
    };
  }

  // onChange = date => { this.setState({startDate: date }); };
  componentWillMount() {
    this.fetchLoginData();
    this.props.currentMenu("totalemi");
  }

  fetchLoginData = () => {
    this.setState({ leftloader: true })
    const decoded = jwt_decode(localStorage.usertoken);
    let phoneno=decoded.phone;
    // let phoneno = "9902922671";

    axios
      .post(config.get("API_URL") + "/users/totalemi-login", {
        mobileNumber: phoneno,
        password: phoneno,
        userType: "Merchant"
      })
      .then((response) => {
        if (response.data.responseCode == "00") {
          this.setState({
            terminalNo: response.data.responseDetails.userDetails.profile.terminals[0].utid,
            userName: response.data.responseDetails.userDetails.name,
            sessionId: response.data.responseDetails.loginSessionDetails.loginSessionId,
             merchantId : response.data.responseDetails.userDetails.profile.merchantId,
            analysisType: "txnAmount",
          })
          this.fetchToolsData(this.state.terminalNo, this.state.userName, this.state.sessionId);
        }
        else { alert("User is not onboarded on Sparcs") }
      });
  }

  fetchToolsData = () => {
    axios
      .post(config.get("API_URL") + "/users/totalemi-emiService", {
        merchantId: this.state.merchantId.toString(),
        utid: this.state.terminalNo,
        loginSessionId: this.state.sessionId,
        name: this.state.userName,
        appVersion: "2.1"
      })
      .then((response) => {
        if (response.data.responseCode == "00") {
          let banksname = [];
          (Object.keys(response.data.responseDetails.banks)).map((value, index) => {
            banksname[index] = { "label": value, "value": index }
          })
          this.setState({ BankList: banksname })
          this.setState({ Banks: response.data.responseDetails.banks, leftloader: false, });

        }
        else {
          alert("Some technical error occured!. Please try again");
        }

      });
  }

  ddlbankChange = (e) => {

    this.setState({ emitabshow: true });
    calculateEMIReq.emiTenures = this.state.Banks[e.label].emiTenures;
    // calculateEMIReq.amount = this.state.EmiAmt;
    calculateEMIReq.bankName = e.label;
    calculateEMIReq.loginSessionId = this.state.sessionId;
    calculateEMIReq.name = this.state.userName;
    this.tenure(three);

  };


  tenure = (e) => {

    this.setState({
      threeMonths: tenurenotselcted,
      sixMonths: tenurenotselcted,
      nineMonths: tenurenotselcted,
      twelveMonths: tenurenotselcted,
    })
    if (e.includes('3 MONTHS')) {
      this.setState({ threeMonths: tenureselcted });
      currTenure = three;
    }
    else if (e.includes('6 MONTHS')) {
      this.setState({ sixMonths: tenureselcted });
      currTenure = six;
    }
    else if (e.includes('9 MONTHS')) {
      this.setState({ nineMonths: tenureselcted });
      currTenure = nine;
    }
    else if (e.includes('12 MONTHS')) {
      this.setState({ twelveMonths: tenureselcted });
      currTenure = twelve;

    }

  };

  calculateEMI = () => {
    if (InputAmt == "") {
      this.setState({alert:true,alertMsg:'Please enter amount'});
    }
    else if (calculateEMIReq.bankName == "" || calculateEMIReq.bankName == undefined) {this.setState({alert:true,alertMsg:'Please select a bank'})  }
    else {
      if ((parseInt(InputAmt)) > 999999) {
        this.setState({alert:true,alertMsg:'Amount should be lesser than 999999'})
      }
      else if ((parseInt(InputAmt)) < 3000) { this.setState({alert:true,alertMsg:'Amount should be greater than 3000'}) }
      else {
        this.setState({ loader: true })
        calculateEMIReq.amount = this.state.EmiAmt;
        calculateEMIReq.merchantId=this.state.merchantId.toString();

        axios
          .post(config.get("API_URL") + "/users/totalemi-emiCalculator", calculateEMIReq)
          .then((response) => {
            if ((response.data.responseMessage.toLowerCase()) == "success") {
              this.setState({ EmiTenures: response.data.responseDetails, Emidetailshow: true, loader: false });
              // console.log(this.state.EmiTenures);

            }
            else {
              alert("Some technical error occured!. Please try again");
            }

          });
      }
    }
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };
  amountChange(evt) {
    InputAmt = evt.target.validity.valid
      ? evt.target.value
      : '';

    this.setState({ EmiAmt: InputAmt });
  }


  toggleunmappedModel() {
    this.setState({
      unmappedModel: !this.state.unmappedModel,
    });
  }
  campaignDropdown = () => {
    this.props.history.push("/admin/promotions");
  };

  goBack = () => {
    this.props.history.push("/admin/brand-emi");
  };


  getTabs = () => {
    return presidents.map((president, index) => ({
      title: president.name,
      getContent: () => president.biography,
      /* Optional parameters */
      key: index,
      tabClassName: "tab",
      panelClassName: "panel",
    }));
  };
  Emitabscolor = () => {
    this.setState({});
  };
  dropdn = () => {
    alert(this.state.drop);
    this.setState({ drop: !this.state.drop });
  };
  //    App = () => <Tabs items={this.getTabs} />;
  onAlertConfirm = () => {
    this.setState({ alert: false })
  }
  render() {
    return (
      <>
        {isMobile && <TopNavbar trn={this.state.terminalNo}/>}

        <div className="fixed-content">
          <div className="container-fluid ">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12 p-top-10">
                <div className="content">
                  <div className="row">

                    <SweetAlert
                      show={this.state.alert}
                      // showCancel
                      // showCloseButton
                      confirmBtnText="ok"
                      // cancelBtnText="No"
                      confirmBtnBsStyle="default"
                      // cancelBtnBsStyle="default"
                      // customIcon="https://raw.githubusercontent.com/djorg83/react-bootstrap-sweetalert/master/demo/assets/thumbs-up.jpg"
                      title="Alert!"
                      onConfirm={this.onAlertConfirm}
                      // onCancel={this.onAlertConfirm}
                      btnSize='lg'
                    >
                      {this.state.alertMsg}
                   </SweetAlert>
                  
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ paddingBottom: "15px" }} >

                      {this.state.leftloader === false ? <div className="rectangle-card">
                        <header className="w3-container">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                            {" "}
                            <h4 style={{ color: "#666666", fontSize: "120%" }}>
                              EMI Calculator
                            </h4>
                          </div>
                        </header>
                        <div className="w3-container" style={{ borderTop: "1px solid darkgray" }}>
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  p-10">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  p-5">
                              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                <p style={{ color: "#777777" }}>
                                  {" "}
                                  Amount (<span className="inr-sign"></span>){" "}
                                </p>
                              </div>
                              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 textcenter-left">
                                <input
                                  type="tel"
                                  id="inputID"
                                  pattern="^[0-9]*\.?[0-9]*$"
                                  maxLength={8}
                                  onInput={this.amountChange.bind(this)}
                                  value={this.state.InputAmt}
                                  placeholder="Enter Amount"
                                  className="form-control plr-20"
                                  style={{border:'1px solid rgba(154, 154, 154, 0.6)'}}

                                  
                                />
                               
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  p-5">
                              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                <p style={{ color: "#777777" }}> Select Bank</p>
                              </div>
                              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <Select
                                  options={this.state.BankList}
                                  onChange={this.ddlbankChange.bind(this)}
                                  className="selectSize"
                                  isSearchable={false}
                                />

                              </div>
                            </div>

                            {this.state.emitabshow && (
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  p-5">
                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                  <p style={{ color: "#777777" }}>
                                    Select Tenure (Months){" "}
                                  </p>
                                </div>
                                <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12">

                                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="row text-center" onClick={() => this.tenure(three)} style={this.state.threeMonths} >
                                      <div style={{ padding: '5px' }}>
                                        <span style={{ display: 'block', fontSize: '14px' }}>3 </span>

                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="row text-center" onClick={() => this.tenure(six)} style={this.state.sixMonths} >
                                      <div style={{ padding: '5px' }}>
                                        <span style={{ display: 'block', fontSize: '14px' }}>6 </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="row text-center" onClick={() => this.tenure(nine)} style={this.state.nineMonths} >
                                      <div style={{ padding: '5px' }}>
                                        <span style={{ display: 'block', fontSize: '14px' }}>9 </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="row text-center" onClick={() => this.tenure(twelve)} style={this.state.twelveMonths} >
                                      <div style={{ padding: '5px' }}>
                                        <span style={{ display: 'block', fontSize: '14px' }}>12 </span>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            )}

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5">
                              <div
                                className="p-lr-10"
                                style={{
                                  fontSize: "15px",
                                  background: "#F47626",
                                  color: "#fff",
                                  padding: "8px 18px",
                                }}
                                onClick={this.calculateEMI}
                              >
                                Calculate EMI
                                                    </div>
                            </div>

                            {/* EMI details card start */}
                          </div>
                        </div>
                      </div>
                        :
                        <BeatLoader
                          css={override}
                          sizeUnit={"px"}
                          size={15}
                          color={'#123abc'}
                          loading={this.state.leftloader}
                        />
                      }

                    </div>

                    {this.state.Emidetailshow &&

                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: "20px" }}>
                        {this.state.loader === false ?
                          <div className="w3-card-4">
                            <header
                              className="w3-container"
                              style={{ borderBottom: "1px solid darkgray" }}
                            >
                              <div className="col-md-12 col-xs-12 col-lg-12 text-center">
                                {" "}
                                <h4
                                  style={{ color: "#666666", fontSize: "120%" }}
                                >
                                  EMI Details
                              </h4>
                              </div>
                            </header>

                            <div className="w3-container" style={{ paddingBottom: '20px' }}>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-5 text-center">
                                {/* <ButtonGroup color="primary" aria-label="outlined primary button group">
                                              <Button size={'large'}  onClick={() =>this.tenure(three)} style={this.state.threeMonths}><p>3 months <span>{`₹ ${this.state.EmiTenures.emiTenures[0]["3 MONTHS"].noCashBack.monthlyAmount}`}</span></p></Button>
                                              <Button size={'large'}  onClick={() =>this.tenure(six)} style={this.state.sixMonths}><p>6 months <span>{`₹ ${this.state.EmiTenures.emiTenures[0]["6 MONTHS"].noCashBack.monthlyAmount}`}</span></p></Button>
                                              <Button size={'large'}  onClick={() =>this.tenure(nine)} style={this.state.nineMonths}><p>9 months <span>{`₹ ${this.state.EmiTenures.emiTenures[0]["9 MONTHS"].noCashBack.monthlyAmount}`}</span></p></Button>
                                              <Button size={'large'}  onClick={() =>this.tenure(twelve)} style={this.state.twelveMonths}><p>12 months <span>{`₹ ${this.state.EmiTenures.emiTenures[0]["12 MONTHS"].noCashBack.monthlyAmount}`}</span></p></Button>
                                  </ButtonGroup> */}


                                {/* <TabComponent heightAdjustMode='Auto' overflowMode='Scrollable' width='98%'>
        <TabItemsDirective>
          <TabItemDirective header={this.headerText[0]}/>
          <TabItemDirective header={this.headerText[1]}/>
          <TabItemDirective header={this.headerText[2]}/>
          <TabItemDirective header={this.headerText[3]}/>
         
        </TabItemsDirective>
      </TabComponent> */}

                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                  <div className="row text-center" onClick={() => this.tenure(three)} style={this.state.threeMonths} >
                                    <div style={{ padding: '5px' }}>
                                      <span style={{ display: 'block', fontSize: '14px' }}>3 Months</span>

                                      <span style={{ display: 'block', fontSize: '14px' }}> {`₹ ${this.state.EmiTenures.emiTenures[0]["3 MONTHS"].noCashBack.monthlyAmount}`}</span>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                  <div className="row text-center" onClick={() => this.tenure(six)} style={this.state.sixMonths} >
                                    <div style={{ padding: '5px' }}>
                                      <span style={{ display: 'block', fontSize: '14px' }}>6 Months</span>

                                      <span style={{ display: 'block', fontSize: '14px' }}>{`₹ ${this.state.EmiTenures.emiTenures[0]["6 MONTHS"].noCashBack.monthlyAmount}`} </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                  <div className="row text-center" onClick={() => this.tenure(nine)} style={this.state.nineMonths} >
                                    <div style={{ padding: '5px' }}>
                                      <span style={{ display: 'block', fontSize: '14px' }}>9 Months</span>

                                      <span style={{ display: 'block', fontSize: '14px' }}>{`₹ ${this.state.EmiTenures.emiTenures[0]["9 MONTHS"].noCashBack.monthlyAmount}`}</span>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                  <div className="row text-center" onClick={() => this.tenure(twelve)} style={this.state.twelveMonths} >
                                    <div style={{ padding: '5px' }}>
                                      <span style={{ display: 'block', fontSize: '14px' }}>12 Months</span>

                                      <span style={{ display: 'block', fontSize: '14px' }}> {`₹ ${this.state.EmiTenures.emiTenures[0]["12 MONTHS"].noCashBack.monthlyAmount}`}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>


                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-10 text-center">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-right">
                                    <p>Bank</p>
                                  </div>
                                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <p>:</p>
                                  </div>
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-left">
                                    <p>{this.state.EmiTenures.bankName}</p>
                                  </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-right">
                                    <p>Interest</p>
                                  </div>
                                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <p>:</p>
                                  </div>
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-left">
                                    <p>{this.state.EmiTenures.emiTenures[0][currTenure].noCashBack.rateOfInterest}% pa</p>
                                  </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-right">
                                    <p>Tenure</p>
                                  </div>
                                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 ">
                                    <p>:</p>
                                  </div>
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-left">
                                    <p>{currTenure}</p>
                                  </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-right">
                                    <p>Amount</p>
                                  </div>
                                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <p>:</p>
                                  </div>
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-left">
                                    <p>
                                      {`₹ ${this.state.EmiTenures.emiTenures[0][currTenure].noCashBack.amount.substring(0, 9)}`}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-right">
                                    <p>Interest</p>
                                  </div>
                                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <p>:</p>
                                  </div>
                                  <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-left">
                                    <p>
                                      {`₹ ${this.state.EmiTenures.emiTenures[0][currTenure].noCashBack.interestAmount}`}
                                    </p>
                                  </div>
                                </div>


                              </div>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-center">
                                  <div className="row" style={reportstyle}>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                                      <p style={{ color: "darkorange", paddingTop: '10px' }}>
                                        <strong>
                                          {`₹ ${this.state.EmiTenures.emiTenures[0][currTenure].noCashBack.monthlyAmount}`}
                                        </strong>
                                      </p>
                                      <p>Monthly EMI</p>
                                    </div>

                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-center">
                                  <div className="row" style={reportstyle}>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-0">
                                      <p style={{ color: "darkorange", paddingTop: '10px' }}>
                                        <strong>
                                          {`₹ ${this.state.EmiTenures.emiTenures[0][currTenure].noCashBack.netAmount}`}
                                        </strong>
                                      </p>
                                      <p>Total EMI Payment </p>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              {/* 
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-10">
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5">
                                <div
                                  className=""
                                  style={{
                                    fontSize: "15px",
                                    background: "#F47626",
                                    color: "#fff",
                                    padding: "8px 18px",
                                  }}
                                >
                                  Done
                                </div>
                              </div>
                            </div> */}


                            </div>
                          </div>
                          :
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={15}
                            color={'#123abc'}
                            loading={this.state.loader}
                          />
                        }
                      </div>
                    }

                    {/* EMI details card end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(IposTools);
